import { render, staticRenderFns } from "./mycollect.vue?vue&type=template&id=e2fabc82&scoped=true&"
import script from "./mycollect.vue?vue&type=script&lang=js&"
export * from "./mycollect.vue?vue&type=script&lang=js&"
import style0 from "./mycollect.vue?vue&type=style&index=0&id=e2fabc82&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2fabc82",
  null
  
)

export default component.exports